import React from 'react';
import { QuickLinks as QuickLinksComponent } from '@thd-olt-component-react/quick-links';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { ImpressionProvider } from '@thd-olt-component-react/impression';
import { arrayOf, shape, string } from 'prop-types';

export function QuickLinks({ id, linkList }) {
  const data = {
    name: 'QuickLinks',
    component: 'QuickLinks',
    type: 'content',
    position: 1,
    id
  };

  return (
    <ErrorBoundary name="quick-links">
      <QueryProvider cacheKey="quick-links-cacheKey">
        <ImpressionProvider data={data}>
          <QuickLinksComponent componentId={id} linkList={linkList} />
        </ImpressionProvider>
      </QueryProvider>
    </ErrorBoundary>
  );
}

QuickLinks.propTypes = {
  id: string,
  linkList: arrayOf(shape({
    id: string,
    href: string,
    label: string,
  })),
};

QuickLinks.defaultProps = {
  id: '',
  linkList: undefined
};
